
const CopyIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <g clipPath="url(#clip0_1325_8716)">
                <path d="M11.6667 4.6665H5.83341C5.18908 4.6665 4.66675 5.18884 4.66675 5.83317V11.6665C4.66675 12.3108 5.18908 12.8332 5.83341 12.8332H11.6667C12.3111 12.8332 12.8334 12.3108 12.8334 11.6665V5.83317C12.8334 5.18884 12.3111 4.6665 11.6667 4.6665Z" stroke="white" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2.33341 9.33317C1.69175 9.33317 1.16675 8.80817 1.16675 8.1665V2.33317C1.16675 1.6915 1.69175 1.1665 2.33341 1.1665H8.16675C8.80842 1.1665 9.33342 1.6915 9.33342 2.33317" stroke="white" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1325_8716">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default CopyIcon